import { render } from "./PortTooltip.vue?vue&type=template&id=228e7ae2"
import script from "./PortTooltip.vue?vue&type=script&lang=js"
export * from "./PortTooltip.vue?vue&type=script&lang=js"

import exportComponent from "/builds/vrs/docker/web/app/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__